import {
  analyticsReduxRegistry,
  DATA_LAYER_SCOPES
} from "seneca-common/features/analytics";
import { getQueryData } from "seneca-common/utils/reactQuery/utils";

import { fetchMySchoolInfoQueryOptions } from "../service/queries";

analyticsReduxRegistry.registerGlobalSelectorsToDataLayerScope(
  DATA_LAYER_SCOPES.SCHOOL,
  {
    name: () => getQueryData(fetchMySchoolInfoQueryOptions())?.name,
    schoolId: () => getQueryData(fetchMySchoolInfoQueryOptions())?.schoolId
  }
);

analyticsReduxRegistry.registerUserPropertiesSelectorsToDataLayerScope({
  name: () => getQueryData(fetchMySchoolInfoQueryOptions())?.name,
  schoolId: () => getQueryData(fetchMySchoolInfoQueryOptions())?.schoolId
});
